import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Emergent-managed Google sign-in entry point.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const GoogleSignInButton = ({ label = "Continue with Google", testid = "google-signin-btn" }) => {
  const start = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={start}
      className="w-full btn-pill h-11 border-border hover:border-primary/50 bg-transparent"
      data-testid={testid}
    >
      <svg viewBox="0 0 24 24" width="17" height="17" className="mr-2.5" aria-hidden="true">
        <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.4a5.5 5.5 0 0 1-2.4 3.6v3h3.9c2.3-2.1 3.6-5.2 3.6-8.8Z"/>
        <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.1-4 1.1a7 7 0 0 1-6.6-4.8H1.4v3.1A11.9 11.9 0 0 0 12 24Z"/>
        <path fill="#FBBC05" d="M5.4 14.4a7.1 7.1 0 0 1 0-4.8V6.5H1.4a11.9 11.9 0 0 0 0 11l4-3.1Z"/>
        <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.5-3.5A11.9 11.9 0 0 0 1.4 6.5l4 3.1A7 7 0 0 1 12 4.8Z"/>
      </svg>
      {label}
    </Button>
  );
};

export default GoogleSignInButton;
